module.exports = __webpack_public_path__ + "static/media/29.afc8f76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/29.jpg
// module id = 290
// module chunks = 0